import React from 'react';
import ToolTip from '../../../../components/Tooltip';

interface Props {
  label: string;
  filters: string[] | undefined;
  styles?: { padding: string };
}

const Tags = ({ label, filters, styles }: Props): React.ReactElement => {
  return (
    <>
      <p className={`mr-1 ${styles?.padding} font-nunitoBold text-sm leading-[21px]`}>{label}:</p>
      <div className="mr-2">
        <p className="m-0 font-nunitoMedium text-sm rounded-[24px] border border-borderGray bg-opaqueNavy px-[10px]">
          {filters ? (filters?.length > 3 ? filters.slice(0, 3).join(', ') : filters.join(', ')) : 'All'}
          {filters && filters?.length > 3 ? (
            <ToolTip
              data={{
                status: 'TAG',
                label: `(+ ${filters?.length - 3} more)`,
                message: filters.slice(3, filters.length).join(', ')
              }}
            />
          ) : (
            ''
          )}
        </p>
      </div>
    </>
  );
};

export default Tags;
